import { gql } from "@apollo/client";

export const GetEmp = gql`
  query GetEmp(
    $token: String!
    $after: Cursor
    $first: Int
    $customer_id: ID!
    $input: EmpQueryData!
    $orderBy: EmpMasterOrder
    $name: String
  ) {
    GetEmp(
      token: $token
      after: $after
      customer_id: $customer_id
      input: $input
      first: $first
      orderBy: $orderBy
      where: {
        or: [{ nameContainsFold: $name }, { mobileContainsFold: $name }]
      }
    ) {
      edges {
        node {
          id
          name
          empType
          address
          place
          state
          pin
          email
          mobile
          status
          gender
          rights
          isLoginCreated
          lastAccessed
          kgid
          metalNo
          customer {
            name
          }
          company {
            name
          }
          subsidiary {
            name
          }
          site {
            name
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const GetEmpAutocomplete = gql`
  query GetEmp(
    $token: String!
    $after: Cursor
    $first: Int
    $customer_id: ID!
    $input: EmpQueryData!
    $orderBy: EmpMasterOrder
    $name: String
    $kgidValue: Int!
  ) {
    GetEmp(
      token: $token
      after: $after
      customer_id: $customer_id
      input: $input
      first: $first
      orderBy: $orderBy
      where: {
        or: [
          { nameContainsFold: $name }
          { mobileContainsFold: $name }
          { kgidIn: [$kgidValue] }
          { metalNoIn: [$kgidValue] }
        ]
      }
    ) {
      edges {
        node {
          id
          name
          empType
          kgid
          metalNo       
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

//Node

export const GetEmpMasterByNodeId = gql`
  query GetEmpMasterByNodeId($id: ID!, $token: String!) {
    node(id: $id, token: $token) {
      id
      ... on EmpMaster {
        id
        name
        empType
        address
        place
        state
        pin
        email
        mobile
        status
        gender
        rights
        lastAccessed
        kgid
        metalNo
        companyID
        subsidiaryID
        siteID
        customer {
          name
        }
      }
    }
  }
`;

export const GetEmployeeByAuthId = gql`
  query GetEmployeeByAuthId($token: String!, $auth_id: ID!) {
    GetEmployeeByAuthId(token: $token, auth_id: $auth_id) {
      id
      name
      empType
      address
      place
      state
      pin
      email
      mobile
      status
      gender
      rights
      lastAccessed
      customerID
    }
  }
`;

export const ExportEmpTemplate = gql`
  query ExportEmpTemplate($token: String!, $customerID: ID!) {
    ExportEmpTemplate(token: $token, customerID: $customerID)
  }
`;

export const ValidateEmpForImport = gql`
  query ValidateEmpForImport(
    $token: String!
    $customerID: ID!
    $input: ImportEmpData!
  ) {
    ValidateEmpForImport(token: $token, customerID: $customerID, input: $input)
  }
`;

export const GetEmpAttendance = gql`
  query GetEmpAttendance(
    $token: String!
    $after: Cursor
    $first: Int
    $customer_id: ID!
    $input: EmpQueryData!
    $orderBy: EmpMasterOrder
    $name: String
  ) {
    GetEmp(
      token: $token
      after: $after
      customer_id: $customer_id
      input: $input
      first: $first
      orderBy: $orderBy
      where: {
        or: [{ nameContainsFold: $name }, { mobileContainsFold: $name }]
      }
    ) {
      edges {
        node {
          id
          name
          empType
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;
